import { MarketingIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useLocation, Link } from 'react-router-dom';
import ShowByRole from 'App/components/ShowByRole';
import { useHandleMenuClick } from 'App/hooks';
import { useTranslationCommon } from 'commons/hooks';
import { useNuvemMarketing } from 'domains/Marketing/hook';
import { MARKETING_ROUTES } from 'domains/Marketing/marketingRoutes';
import {
  menuSecondaryMarketingAutomationAppsClick,
  menuSecondaryMarketingAutomationClick,
  menuSecondaryAutomationsClick,
  menuSecondaryEmailMarketingClick,
} from './tracking';

function MarketingAutomationMenu() {
  const t = useTranslationCommon();
  const { pathname } = useLocation();
  const { handleClickItem, handleClickAccordion } = useHandleMenuClick();
  const {
    hasNuvemMarketingRole,
    hasNuvemMarketingApplication,
    hasAccessToNuvemMarketing,
  } = useNuvemMarketing();

  const handleClickFeaturedApplications = () => {
    menuSecondaryMarketingAutomationAppsClick();
    handleClickItem();
  };

  const handleClickMarketingAutomation = () => {
    menuSecondaryMarketingAutomationClick();
    handleClickItem();
  };

  const handleClickAutomations = () => {
    menuSecondaryAutomationsClick();
    handleClickItem();
  };

  const handleClickEmailMarketing = () => {
    menuSecondaryEmailMarketingClick();
    handleClickItem();
  };

  const isActive =
    pathname.startsWith(MARKETING_ROUTES.marketingAutomation) ||
    pathname.startsWith(MARKETING_ROUTES.emailMarketing) ||
    pathname.startsWith(MARKETING_ROUTES.featuredApplications);

  const targetUrl = MARKETING_ROUTES.marketingAutomation;

  return hasAccessToNuvemMarketing && hasNuvemMarketingRole ? (
    <MenuButton.Accordion
      contentid="content-marketing-apps"
      menuButton={{
        id: 'control-marketing',
        label: t('menu.manage.marketingApps.title'),
        startIcon: MarketingIcon,
        'aria-controls': 'content-marketing-apps',
        onClick: handleClickAccordion,
      }}
      open={isActive}
      active={isActive}
      as={Link}
      to={targetUrl}
    >
      {hasNuvemMarketingApplication ? (
        <>
          <MenuButton
            as={Link}
            to={MARKETING_ROUTES.marketingAutomation}
            onClick={handleClickAutomations}
            label={t('menu.manage.marketingApps.automations')}
            active={pathname.startsWith(MARKETING_ROUTES.marketingAutomation)}
          />
          <MenuButton
            as={Link}
            to={`${MARKETING_ROUTES.emailMarketing}#/email-marketing`}
            onClick={handleClickEmailMarketing}
            label={t('menu.manage.marketingApps.emailMarketing')}
            active={pathname.startsWith(MARKETING_ROUTES.emailMarketing)}
          />
        </>
      ) : (
        <MenuButton
          as={Link}
          to={MARKETING_ROUTES.marketingAutomation}
          onClick={handleClickMarketingAutomation}
          label={t('menu.manage.marketingApps.marketingAutomation')}
          active={pathname.startsWith(MARKETING_ROUTES.marketingAutomation)}
        />
      )}

      <MenuButton
        as={Link}
        to={MARKETING_ROUTES.featuredApplications}
        onClick={handleClickFeaturedApplications}
        label={t('menu.manage.marketingApps.featuredApplications')}
        active={pathname.startsWith(MARKETING_ROUTES.featuredApplications)}
      />
    </MenuButton.Accordion>
  ) : (
    <ShowByRole includeRoles={['full', 'marketing']}>
      <MenuButton
        as={Link}
        to={MARKETING_ROUTES.featuredApplications}
        startIcon={MarketingIcon}
        onClick={handleClickFeaturedApplications}
        label={t('menu.manage.marketingApps.title')}
        active={pathname.startsWith(MARKETING_ROUTES.featuredApplications)}
      />
    </ShowByRole>
  );
}

export default MarketingAutomationMenu;
